import {Request} from "../core/request";
import {AuthHeader} from "../core/token";
import {CourseLocation, CourseSubject} from "./location";

export async function getCoursesLocations(): Promise<CourseLocation[]> {
    const resp = await Request.get(`/teacher/course_info/course_location`, {
        headers: AuthHeader(),
    })
    return resp.data
}

export async function getCoursesSubjects(): Promise<CourseSubject[]> {
    const resp = await Request.get(`/teacher/course_info/subject`, {
        headers: AuthHeader(),
    })
    return resp.data
}

export type CourseMarked = {
    MarkAdmin: number;
    MarkAdminName: string;
    MarkTime: string;
    uuid: string;
    TimeStr: string;
    StartTime: number;
    EndTime: number;
    ExcludedMarkTime: boolean;
}


export type CourseDetail = {
    ID: number;
    UserId: number;
    UserName: string;
    CourseLocation: string;
    CourseLocations: string[];
    StartTime: number;
    EndTime: number;
    TimeStr: string;
    WeekDay: number;
    Subject: string;
    Subjects: string[];
    Grade: number;
    Grades: number[];
    Term: number;
    canMark: boolean;
    // MarkAdmin: number | null;
    // MarkAdminName: string;

    marked?: CourseMarked[]
}

export async function getCourses(): Promise<CourseDetail[]> {
    const resp = await Request.get<CourseDetail[]>(`/teacher/course_info/`, {
        headers: AuthHeader(),
    })
    return resp.data as CourseDetail[]
}

export type startEndTime = {
    start_time: number;
    end_time: number;
}

export async function updateCourse(
    id: number, // 课程ID
    course_location: string,
    course_locations: string[],
    start_time: number, end_time: number,
    week_day: number,
    subject: string,
    subjects: string[],
    grade: number,
    grades: number[],
    term: number,
    startEndTime: startEndTime[],
) {
    return await Request.put(`/teacher/course_info/`, {
        id: id,
        course_location: course_location,
        course_locations: course_locations,
        start_time: start_time,
        end_time: end_time,
        week_day: week_day,
        subject: subject,
        subjects: subjects,
        grade: grade,
        grades: grades,
        term: term,
        excluded_mark_times: startEndTime,
    }, {headers: AuthHeader()})
}

export async function createCourse(
    course_location: string,
    course_locations: string[],
    start_time: number, end_time: number,
    week_day: number,
    subject: string,
    subjects: string[],
    grade: number,
    grades: number[],
    term: number,
    startEndTime: startEndTime[],
) {
    return await Request.post(`/teacher/course_info/`, {
        course_location: course_location,
        course_locations: course_locations,
        start_time: start_time,
        end_time: end_time,
        week_day: week_day,
        subject: subject,
        subjects: subjects,
        grade: grade,
        grades: grades,
        term: term,
        excluded_mark_times: startEndTime,
    }, {headers: AuthHeader()})
}

export async function enableCourse(id: number, enable: boolean) {
    return await Request.post(`/teacher/course_info/enable/${id}`, {enable: enable}, {headers: AuthHeader()})
}

export async function deleteCourse(id: number) {
    return await Request.delete(`/teacher/course_info/${id}`, {headers: AuthHeader()})
}


// ----------- 管理接口
export async function affairsSearchCourse(query: Record<string, any>): Promise<{
    total: number,
    data: CourseDetail[],
}> {
    const queryString = new URLSearchParams(query).toString();
    const resp = await Request.get(`/admin/information/?${queryString}`, {headers: AuthHeader()});
    return resp.data
}


export async function affairsMarkCourse(id : number, startTime: number, endTime: number) : Promise<any>{
    const resp = await Request.post(`/admin/information/${id}/mark`, {
        StartTime: startTime,
        EndTime: endTime,
    }, {headers: AuthHeader()});
    return resp.data
}


export async function affairsUnMarkCourse(id: number, uuid:string) : Promise<any>{
    const resp = await Request.post(`/admin/information/${id}/unmark/${uuid}/`, {}, {headers: AuthHeader()});
    return resp.data
}

export async function getAffairsMarkedCourse(): Promise< CourseDetail[]>{
    const resp = await Request.get(`/admin/information/marks`, {headers: AuthHeader()});
    return resp.data
}

// export async function affairsMarkInformation() {
//     return await Request.get(`/admin/information/marks`, {headers: AuthHeader()});
// }
//
//
// export async function affairsRecentlyMarkInformation() {
//     return await Request.get(`/admin/information/marks/recently`, {headers: AuthHeader()});
// }
//
// export async function affairsCreateMarkInformation(id: number) {
//     return await Request.post(`/admin/information/mark`, {id: id}, {headers: AuthHeader()});
// }
//
//
// export async function affairsDeleteMarkInformation(id: number) {
//     return await Request.delete(`/admin/information/mark/${id}`, {headers: AuthHeader()});
// }
